'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/ModalSpinner/ModalSpinner.js';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _spinner = require('./spinner.gif');

var _spinner2 = _interopRequireDefault(_spinner);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./ModalSpinner.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  isActive: _propTypes2.default.bool,
  message: _propTypes2.default.string
};
var defaultProps = {
  isActive: false,
  message: null
};

var ModalSpinner = function (_PureComponent) {
  _inherits(ModalSpinner, _PureComponent);

  function ModalSpinner() {
    _classCallCheck(this, ModalSpinner);

    return _possibleConstructorReturn(this, (ModalSpinner.__proto__ || Object.getPrototypeOf(ModalSpinner)).apply(this, arguments));
  }

  _createClass(ModalSpinner, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)('ModalSpinner', {
          'is-active': this.props.isActive
        }),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 20
        },
        __self: this
      }, _react2.default.createElement('img', {
        className: 'ModalSpinner-image',
        src: _spinner2.default,
        alt: 'Loading spinner',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 21
        },
        __self: this
      }), _react2.default.createElement('p', {
        className: 'ModalSpinner-text',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 25
        },
        __self: this
      }, this.props.message));
    }
  }]);

  return ModalSpinner;
}(_react.PureComponent);

ModalSpinner.propTypes = propTypes;
ModalSpinner.defaultProps = defaultProps;
exports.default = ModalSpinner;